export function trackShareArticleClick(articleTitle, socialMedia) {
  window.dataLayer.push({
    event: 'share_click',
    article_title: articleTitle,
    article_url: encodeURIComponent(window.location.href),
    article_share_method: socialMedia,
  });
}

export function trackArticleBookmarkClick(articleTitle, bookmarkAction) {
  window.dataLayer.push({
    event: 'bookmark_click',
    article_title: articleTitle,
    article_url: encodeURIComponent(window.location.href),
    bookmark_click: bookmarkAction,
  });
}
